export const TRANSACTION_HISTORY_WIDGET = [
    { span: 15, height: "96px", classes: "marginTop-16" },
    { span: 15, height: "96px", classes: "marginTop-16" },
    { span: 15, height: "96px", classes: "marginTop-16" },
    { span: 15, height: "96px", classes: "marginTop-16" },
    { span: 15, height: "96px", classes: "marginTop-16" },
    { span: 15, height: "96px", classes: "marginTop-16" },
    { span: 15, height: "96px", classes: "marginTop-16" },
]
